// เครื่องหมายของยอดเงินในรายงานภาษีขาย สำหรับเอกสารที่ถูกยกเลิก
//
// เอกสารที่ยกเลิกต้องแสดงเป็น "การกลับรายการ" ของยอดที่เคยลงไว้:
//   ใบขายปกติเคยลงเป็นบวก  → ยกเลิกแล้วแสดงเป็นลบ
//   ใบลดหนี้เคยลงเป็นลบอยู่แล้ว → ยกเลิกแล้วต้องแสดงเป็นบวก ไม่ใช่ลบซ้ำ
//
// วิธีรู้ว่าเดิมเป็นใบลดหนี้มีสองทาง เพราะใบที่ยกเลิกมาจากสองที่:
//   - นำเข้ามาพร้อมสถานะยกเลิก ยังเป็น @DocType 4 อยู่
//   - กดปุ่มยกเลิกในระบบ ถูกเปลี่ยนเป็น @DocType 7 แล้วเก็บประเภทเดิมไว้ที่ @OriginalDocType
//
// อยู่ในไฟล์นี้เพราะตาราง, ไฟล์ CSV และไฟล์ Excel ของรายงานเดียวกันต้องได้เครื่องหมาย
// ตรงกันทั้งสามที่ (เดิมต่างคนต่างคิดเอง แล้วออกมาไม่ตรงกัน)

export function isCancelledDoc(doc) {
  if (!doc) {
    return false
  }
  const docData = doc["@DocData"]
  return Boolean(docData && docData.docStatus === "C")
}

export function wasCreditNote(doc) {
  if (!doc) {
    return false
  }
  return doc["@DocType"] === 4 || doc["@OriginalDocType"] === 4
}

// ยอดที่ควรแสดงของเอกสารใบนี้ (หน่วยสตางค์ เหมือนที่เก็บใน Firestore)
export function reportAmount(doc, value) {
  const amount = Number(value) || 0
  if (!isCancelledDoc(doc)) {
    return amount
  }
  return wasCreditNote(doc) ? Math.abs(amount) : -Math.abs(amount)
}

export default reportAmount
